export default "__VITE_ASSET__6f10799a__"